import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import {
  AddToCart,
  BrandPoductsApi,
  MoreData,
  setItemData,
} from "../components/Redux/Action";
import "./../components/Body/Body.css";
import "./ProductsPage.css";

// import {Helmet} from "react-helmet";
import { MdShoppingCart } from "react-icons/md";
import { toast } from "react-toastify";

const BrandProduct = () => {
  // // console.log("#########################"+state.code)

  const hddispatch = useDispatch();
  const DepartmentData = useSelector((state) => state.ReducerDepData);
  const Changename = useSelector((state) => state.ReducerChangeName);
  const pFullD = useSelector((state) => state.ReducerMoreData);
  // const brandInfo= useSelector(state => state.ReducerBrandsInfo)
  const brandInfo = useSelector((state) => state.ReducerBrandProducts);
  // // console.log("######################"+brandInfo +"(((((%%%%%%%%%%%%%%%%%%%%%%)))))))")
  const [depData, setDepData] = useState(null);
  const [brandData9, setBrandData9] = useState(null);
  // // console.log('product more data'+Changename)
  const [MData, setMDate] = useState([]);
  const [vegproDatamore, setVegproDatamore] = useState();
  const [count, setCount] = useState(0);
  const [Last, setLast] = useState(10);
  // let a = localStorage.getItem("code")
  const [code, setCode] = useState(localStorage.getItem("code"));

  // const [partdepData, setPartdepData] = useState(null)

  // // console.log(window.sabhadding)
  // const groop = window.sabhadding

  const [Value, setValue] = useState(null);

  // function axy(){
  //     // console.log("this data from redux"+pFullD)
  // }
  // let a = localStorage.getItem("code")
  // // console.log("%%%%%%%%%%%%%%+" + a)

  useEffect(() => {
    brand_Api();
  }, []);

  function brandFullData() {
    // let a = localStorage.getItem("code")
    const url_full = `${window.sbapi}/api/product/ProductsByBrand?BrandCode=&FromIndex=1&ToIndex=20&BusinessId=0000000001`;
    // // console.log("#########****************@@@@@@@@@@@@@"+ code)
    code === "all-data"
      ? fetch(url_full)
          .then((res) => res.json())
          .then((results) => {
            const brandData = results?.data?.map((item) => {
              item.qty = 1;
              return { ...item };
            });
            setVegproDatamore(brandData);
          })
      : fetch(
          `${window.sbapi}/api/product/ProductsByBrand?BrandCode=${code}&FromIndex=1&ToIndex=20&BusinessId=0000000001`
        )
          .then((res) => res.json())
          .then((results) => {
            const brandData = results?.data?.map((item) => {
              item.qty = 1;
              return { ...item };
            });
            setVegproDatamore(brandData);
          });
  }

  function loadMoreD(dep, grup) {
    console.warn(dep + grup + "product more data" + Changename);
    // alert("mesage"+Changename)

    // // console.log(dep)
    if (count == 0) {
      fetch(
        `${window.sbapi}//api/product/ProductsByBrand?BrandCode=&FromIndex=1&ToIndex=200&BusinessId=0000000001`
      )
        .then((res) => res.json())

        .then((json) => {
          const data = json?.data?.map((item) => {
            item.qty = 1;
            return { ...item };
          });
          // localStorage.setItem("MYData",JSON.stringify(data))
          setMDate(data);
          hddispatch(MoreData(data));

          // hddispatch({
          //     type: 'more data',
          //     data: data
          // });
          console.warn(MData);
          var dataml = MData.slice(0, 5);
          setVegproDatamore(dataml);
          setCount(count + 1);
        });
    } else if (count != 0 && count < Math.abs(MData.length / 10)) {
      var start = 0;
      //  var  last=20
      var pdata = MData.slice(start, Last + count * 12);

      setVegproDatamore(pdata);
      //  setLast(Last)
      // // console.log("count"+count)
      console.warn("data that is render" + pdata.length);

      setCount(count + 1);
    }
  }

  useEffect(() => {
    if (brandInfo !== "abc") {
      const updatedData = brandInfo.map((item) => {
        item.isShown = false;
        return { ...item };
      });

      setVegproDatamore(updatedData);
    }

    // setPartdepData(window.ghadding)
  }, [brandInfo]);
  //    useEffect(()=>{
  //     brandFullData()
  //    },[])

  useEffect(() => {
    if (DepartmentData !== "abc") {
      const updatedData = DepartmentData.map((item) => {
        item.isShown = false;
        return { ...item };
      });

      setDepData(updatedData);
    }
    // // console.log(Value)
    // setPartdepData(window.ghadding)
  }, [DepartmentData]);
  // const Newvalue=()=>{
  //     hddispatch(PoductsApi(Value, ''))
  // }
  // window.addEventListener('scroll',()=>{
  //     const {scrollTop,scrollHeight,clientHeight}=document.documentElement;
  //     if(scrollTop+clientHeight>=scrollHeight){
  //         // console.log("i m bottom")

  //        Newvalue();

  //     }
  // })

  async function brand_Api() {
    let response = await fetch(
      `${window.sbapi}/api/product/getbrands?BusinessId=0000000001`
    );
    console.log("response---", response);
    response = await response.json();

    let d = await response?.data?.map((it, k) => {
      it.isShown = false;
      return { ...it };
    });
    setBrandData9(d);
  }

  return (
    <>
      {/* <Helmet>
        <meta name="description" content="Vape House offers wide variety of E-Liquids Including All The Branded E-Liquids And Much More..Please Click On This Link For More"/>
            <title>Vape House offers wide variety of E-Liquids Including All The Branded E-Liquids And Much More.</title>
        </Helmet> */}

      <Header />

      <div className="productspage">
        <div className="slider-bar">
          <div className="slidebar_conatainer">
            {
              //depData
              // brandData
              brandData9?.map((item, index) => {
                return (
                  <div
                    className="menu_container2"
                    // onMouseOver={() => {
                    //     depData[index].isShown = true
                    //     setDepData([...depData])
                    // }}
                    // onMouseLeave={() => {
                    //     depData[index].isShown = false
                    //     setDepData([...depData])
                    // }}
                    // onClick={() => {
                    //   var dep = depData[index].value = item.departmentCode
                    //   alert(dep)
                    // }
                    // }
                    onClick={(e) => {
                      hddispatch(BrandPoductsApi(item.code));
                      // console.log("------------------ > data clock")
                      // localStorage.setItem("code", item.code)

                      // console.warn('dep------>',dep)

                      // e.stopPropagation();

                      // setPartdepData(item.departmentCode)
                    }}
                  >
                    <p>{item.name}</p>

                    {/* <span className='sab_menu2'>
                                            {
                                                item.groups.map((it) => {
                                                    return (
                                                        item.isShown ?

                                                            <Link to={'/productspage'} onClick={(e) => {
                                                                var dep = depData[index].value = item.departmentCode;
                                                                var grup = depData[index].value = it.groupCode;
                                                                // var depName = depData[index].value = item.departmentName;
                                                                // // console.log("this is a department"+depName)

                                                                hddispatch(PoductsApi(dep, grup));
                                                                hddispatch(ChangeName({
                                                                    department:dep,
                                                                    group:grup
                                                                    
                                                                }))
                                                                e.stopPropagation();
                                                            }} >
                                                                <p>{it.groupName}</p>
                                                            </Link>
                                                            : null
                                                    )
                                                })
                                            }
                                        </span> */}
                  </div>
                );
              })
            }
          </div>
        </div>

        <div className="products">
          {/* <h1>{ Changename.department? Changename.department :"Products"   }</h1> */}
          <h1>BRANDS PRODUCTS</h1>
          {/* <div style={{ paddingTop: "50px", backgroundColor: "white" }}>
                        <Allapiproduct />
                    </div> */}

          <div
            className="product-main-body"
            style={{ backgroundColor: "white" }}
          >
            {vegproDatamore ? (
              vegproDatamore?.map((item, index) => {
                return (
                  <div className="product_container1">
                    {item.promoPercentage ? (
                      <span className="discount-offers">
                        {" "}
                        {item.promoPercentage}% OFF
                      </span>
                    ) : (
                      ""
                    )}
                    <Link
                      to={"/productdetail"}
                      state={{ item }}
                      onClick={() => {
                        window.scrollTo(0, 0);
                        hddispatch(setItemData(item));
                      }}
                    >
                      <img
                        src={`${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`}
                      />
                    </Link>

                    <p className="P-product">{item.description}</p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "-9px",
                      }}
                    >
                      <span className="cr-price">
                        Rs.&nbsp;
                        {item?.promoPercentage
                          ? Math.round(
                              item?.unitRetail -
                                (item?.unitRetail * item?.promoPercentage) / 100
                            )
                          : item?.unitRetail}
                      </span>
                      {item?.promoPercentage > 0 ? (
                        <del className="cr-price" style={{ color: "red" }}>
                          Rs. {item?.unitRetail}
                        </del>
                      ) : item?.marketRetail > item?.unitRetail ? (
                        <del className="cr-price" style={{ color: "red" }}>
                          Rs. {item?.marketRetail}
                        </del>
                      ) : null}
                    </div>
                    <div className="product-cart">
                      <div className="product-cart2">
                        <button
                          onClick={() => {
                            hddispatch(AddToCart(item));
                            toast.success("Product Added Successfully ", {
                              position: "top-center",
                              autoClose: 1000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                            });
                          }}
                        >
                          <MdShoppingCart />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <ClipLoader color={"red"} loading={true} size={100} />
            )}
          </div>

          <div className="load" style={{ textAlign: "center" }}>
            {/* <button style={{ border: "0.1px solid", color: "white", backgroundColor: "#005AB5", borderRadius: 10, cursor: "pointer", padding: "10px" }} className={"load-More"}
     onClick={() => {
      
        //  hddispatch(PoductsApi(Changenames.dep, Changenames.grup, '', 1, mCount))
        
        //  setMCount(mCount + 15)
        hddispatch(BrandPoductsApi("all-data"))
        // localStorage.setItem("code", "all-data")
        //  hddispatch

     }}>
     Load More
 </button>  */}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BrandProduct;
